import { render, staticRenderFns } from "./NewSupplierProducts.vue?vue&type=template&id=4c275b7e&scoped=true&"
import script from "./NewSupplierProducts.vue?vue&type=script&lang=js&"
export * from "./NewSupplierProducts.vue?vue&type=script&lang=js&"
import style0 from "./NewSupplierProducts.vue?vue&type=style&index=0&id=4c275b7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c275b7e",
  null
  
)

export default component.exports